import { create } from "zustand";
import { persist } from "zustand/middleware";
import {
  THEME_MODE_STORAGE_KEY,
  createLocalStorageJSONStorage,
} from "./appStorage";

const useThemeStore = create(
  persist(
    (set) => ({
      themeMode: "dark",
      setThemeMode: (mode) => {
        const nextMode = ["light", "dark", "system"].includes(mode) ? mode : "dark";
        set({ themeMode: nextMode });
      },
    }),
    {
      name: THEME_MODE_STORAGE_KEY,
      storage: createLocalStorageJSONStorage(),
      partialize: (state) => ({ themeMode: state.themeMode }),
    }
  )
);

export const selectThemeMode = (state) => state.themeMode;
export const selectSetThemeMode = (state) => state.setThemeMode;

export default useThemeStore;
